import { ExplorerFocusArea } from 'constants/';
import ETreeActionTypes from 'enums/ETreeActionTypes';
import ETreeGroupTypes from 'enums/ETreeGroupTypes';
import ETreeSortTypes from 'enums/ETreeSortTypes';
import EViewType from 'enums/EViewType';
import React from 'react';

type TTreeContext = {
  copyNodeId: number;
  setCopyNodeId: (e: number) => void;

  operationType: ETreeActionTypes;
  setOperationType: (e: ETreeActionTypes) => void;

  copyNodeIdParent: number;
  setCopyNodeIdParent: (e: number) => void;

  copyNodeType: string;
  setCopyNodeType: (e: string) => void;

  copyNodeParentId: number;
  setCopyNodeParentId: (e: number) => void;

  copyNodeName: string;
  setCopyNodeName: (e: string) => void;

  sameNodeCopyId: number;
  setSameNodeCopyId: (e: number) => void;

  currentOperation: string;
  setCurrentOperation: (e: string) => void;

  showCommandPanel: boolean;
  setShowCommandPanel: (e: boolean) => void;

  viewType: EViewType;
  setViewType: (e: EViewType) => void;

  groupBy: ETreeGroupTypes;
  setGroupBy: (e: ETreeGroupTypes) => void;

  sortBy: ETreeSortTypes;
  setSortBy: (e: ETreeSortTypes) => void;

  focusedArea: ExplorerFocusArea;
  setFocusedArea: React.Dispatch<React.SetStateAction<ExplorerFocusArea>>;
};

const TreeContext = React.createContext<TTreeContext>({
  copyNodeId: -1,
  setCopyNodeId: (e) => {},

  operationType: ETreeActionTypes.None,
  setOperationType: (e) => {},

  copyNodeIdParent: 0,
  setCopyNodeIdParent: (e) => {},

  copyNodeType: '',
  setCopyNodeType: (e) => {},

  copyNodeParentId: -1,
  setCopyNodeParentId: (e) => {},

  copyNodeName: '',
  setCopyNodeName: (e) => {},

  sameNodeCopyId: -1,
  setSameNodeCopyId: (e) => {},

  currentOperation: 'In Progress',
  setCurrentOperation: (e) => {},

  showCommandPanel: false,
  setShowCommandPanel: (e) => {},

  viewType: EViewType.ListView,
  setViewType: (e) => {},

  groupBy: ETreeGroupTypes.Type,
  setGroupBy: (e) => {},

  sortBy: ETreeSortTypes.Type,
  setSortBy: (e) => {},

  focusedArea: null,
  setFocusedArea: (e) => {},
});

export default TreeContext;
